import React from 'react';
import { Redirect, Route as ReactDomRoute, RouteProps as ReactDomRouteProps } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Main from '../pages/Main';

interface RouteProps extends ReactDomRouteProps {
  isPrivate?: boolean;
  component: React.ComponentType;
}

const Route: React.FC<RouteProps> = ({ 
  isPrivate = false,
  component: Component,
  ...rest
}) => {
  const { jwt } = useAuth();

  return <ReactDomRoute 
    {...rest}
    render={(({ location }) => {
      return isPrivate === !!jwt 
      ? location.pathname === '/login' 
        ? (
          <Component />
        ) 
        : (
          <Main>
            <Component />
          </Main>
        )
      : (
        <Redirect
          to={{
            pathname: isPrivate ? '/login' : '/',
            state: { from: location },
          }}
        />
      );
    })}
  />
};

export default Route;